import React from 'react';
import { createRoot } from 'react-dom/client';
import YoutubeIframe from './youtube-iframe';

export default (element, data) => {
  const init = () => {
    const root = createRoot(element);
    root.render(<YoutubeIframe {...data} />);
  };

  init();
};
